import React from 'react';
import { whatsAppUrl } from '../utils/whatsapp.jsx';

const SIZE = 60;

export function WhatsAppFab() {
    return (
        <a
            href={whatsAppUrl()}
            target="_blank"
            rel="noopener noreferrer"
            style={{
                position: 'fixed',
                bottom: 84,
                right: 25,
                zIndex: 9999,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                width: SIZE,
                height: SIZE,
                textDecoration: 'none',
            }}
            aria-label="WhatsApp"
        >
            <img
                src="/images/footer/whatsapp_background.webp"
                alt="WhatsApp"
                width={SIZE}
                height={SIZE}
                loading="lazy"
                decoding="async"
                style={{ borderRadius: '50%', boxShadow: '0 4px 12px rgba(0,0,0,0.25)' }}
            />
        </a>
    );
}
